// extracted by mini-css-extract-plugin
module.exports = {"inventory_chart":"InventoryFlow_inventory_chart__3YYMX","inventory_chart_title":"InventoryFlow_inventory_chart_title__1QkXw"};